/* tslint:disable */
/* eslint-disable */
/**
 * Docusign API
 * Docusign is a service that allows the user to send the documents for signing
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: o365g_ordertakingteam_irssemal@ingka.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SignRequestCarbonCopy
 */
export interface SignRequestCarbonCopy {
    /**
     * Indicates the number of times that the recipient has been through a signing completion for the signing request
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    completedCount?: string;
    /**
     * Timestamp indicating when the recipient declined the signing request
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    declinedDateTime?: string;
    /**
     * The reason provided by the recipient for declining the signing request
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    declinedReason?: string;
    /**
     * Timestamp indicating when the signing request was delivered to the recipient
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    deliveredDateTime?: string;
    /**
     * The method used to deliver the signing request to the recipient
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    deliveryMethod?: string;
    /**
     * The recipient’s email address used for notifications and signing request delivery
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    email?: string;
    /**
     * The full legal name of the recipient
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    name?: string;
    /**
     * A local reference that senders use to map recipients to other objects
     * @type {number}
     * @memberof SignRequestCarbonCopy
     */
    recipientId?: number;
    /**
     * The globally-unique identifier (GUID) representing this recipient within the signing request
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    recipientIdGuid?: string;
    /**
     * Specifies the type of recipient, such as “signer” or “carbon copy
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    recipientType?: string;
    /**
     * Specifies the role name associated with the recipient
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    roleName?: string;
    /**
     * Specifies the order in which this recipient receives the envelope, relative to other recipients
     * @type {number}
     * @memberof SignRequestCarbonCopy
     */
    routingOrder?: number;
    /**
     * The UTC timestamp when the envelope was sent
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    sentDateTime?: string;
    /**
     * The UTC timestamp when the envelope was signed by the recipient
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    signedDateTime?: string;
    /**
     * The unique user ID associated with this recipient DocuSign account
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    userId?: string;
    /**
     * The current status of the recipient (e.g., sent, delivered, declined, completed)
     * @type {string}
     * @memberof SignRequestCarbonCopy
     */
    status?: string;
}

/**
 * Check if a given object implements the SignRequestCarbonCopy interface.
 */
export function instanceOfSignRequestCarbonCopy(value: object): boolean {
    return true;
}

export function SignRequestCarbonCopyFromJSON(json: any): SignRequestCarbonCopy {
    return SignRequestCarbonCopyFromJSONTyped(json, false);
}

export function SignRequestCarbonCopyFromJSONTyped(json: any, ignoreDiscriminator: boolean): SignRequestCarbonCopy {
    if (json == null) {
        return json;
    }
    return {
        
        'completedCount': json['completedCount'] == null ? undefined : json['completedCount'],
        'declinedDateTime': json['declinedDateTime'] == null ? undefined : json['declinedDateTime'],
        'declinedReason': json['declinedReason'] == null ? undefined : json['declinedReason'],
        'deliveredDateTime': json['deliveredDateTime'] == null ? undefined : json['deliveredDateTime'],
        'deliveryMethod': json['deliveryMethod'] == null ? undefined : json['deliveryMethod'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'] == null ? undefined : json['name'],
        'recipientId': json['recipientId'] == null ? undefined : json['recipientId'],
        'recipientIdGuid': json['recipientIdGuid'] == null ? undefined : json['recipientIdGuid'],
        'recipientType': json['recipientType'] == null ? undefined : json['recipientType'],
        'roleName': json['roleName'] == null ? undefined : json['roleName'],
        'routingOrder': json['routingOrder'] == null ? undefined : json['routingOrder'],
        'sentDateTime': json['sentDateTime'] == null ? undefined : json['sentDateTime'],
        'signedDateTime': json['signedDateTime'] == null ? undefined : json['signedDateTime'],
        'userId': json['userId'] == null ? undefined : json['userId'],
        'status': json['status'] == null ? undefined : json['status'],
    };
}

export function SignRequestCarbonCopyToJSON(value?: SignRequestCarbonCopy | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'completedCount': value['completedCount'],
        'declinedDateTime': value['declinedDateTime'],
        'declinedReason': value['declinedReason'],
        'deliveredDateTime': value['deliveredDateTime'],
        'deliveryMethod': value['deliveryMethod'],
        'email': value['email'],
        'name': value['name'],
        'recipientId': value['recipientId'],
        'recipientIdGuid': value['recipientIdGuid'],
        'recipientType': value['recipientType'],
        'roleName': value['roleName'],
        'routingOrder': value['routingOrder'],
        'sentDateTime': value['sentDateTime'],
        'signedDateTime': value['signedDateTime'],
        'userId': value['userId'],
        'status': value['status'],
    };
}

